export default "__VITE_ASSET__DQwTAsPe__"